export default __webpack_public_path__ + "static/media/zip.dcf048cb.svg";